import React from 'react';
import { createPortal } from 'react-dom';
import Modal from '../Modal/Modal';
import './ActionConfirmModal.css';

const ActionConfirmModal = ({
    isOpen,
    onClose,
    onConfirm,
    title,
    message,
    confirmText = 'Continuar',
    cancelText = 'Revisar',
    closeOnBackdropClick = false
}) => {
    if (!isOpen) return null;

    const handleConfirm = () => {
        onConfirm();
    };

    return createPortal(
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            size="medium"
            showCloseButton={true}
            closeOnBackdropClick={closeOnBackdropClick}
            overlayZIndex={1100}
            manageBodyScroll={false}
        >
            <div className="action-confirm-modal">
                {title && <h3 className="action-confirm-title">{title}</h3>}
                <div className="action-confirm-content">
                    {typeof message === 'string' ? (
                        <p className="action-confirm-message">{message}</p>
                    ) : (
                        <div className="action-confirm-message">{message}</div>
                    )}
                </div>
                <div className="action-confirm-actions">
                    <button
                        type="button"
                        className="action-confirm-btn action-confirm-btn-cancel"
                        onClick={onClose}
                    >
                        {cancelText}
                    </button>
                    <button
                        type="button"
                        className="action-confirm-btn action-confirm-btn-confirm"
                        onClick={handleConfirm}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </Modal>,
        document.body
    );
};

export default ActionConfirmModal;
